import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowOutTopLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-arrow-out-top-left, undock, box, arrow"} maskId="square-filled-radius-0-stroke-1-IconSquareArrowOutTopLeft"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H11V4H4.70711L11.2071 10.5L10.5 11.2071L4 4.70711V11H3V3ZM13 6H22V22H6V13H7V21H21V7H13V6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareArrowOutTopLeft;
